/* eslint-disable */
import { VehicleCapacity } from "./vehicle-capacity";
import { VehicleConfig } from "./vehicle-config";

export class VehicleType {
    id: number | undefined;
    name: string | undefined;
    description: string | undefined;
    imageUrl: string | undefined;
    isEquipment: boolean | undefined;
    vehicleCapacities: VehicleCapacity[] = [];
    vehicleConfigs: VehicleConfig[] = [];
}